<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 27.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<path id="Path_357" style="fill:#5FB546;" d="M12.1,0c-6.6,0-12,5.4-12,12s5.4,12,12,12s12-5.4,12-12S18.7,0,12.1,0z M12.1,22.7
	C6.2,22.7,1.4,17.9,1.4,12C1.4,6.1,6.1,1.3,12,1.3c2.7,0,5.3,1,7.3,2.8c1,0.9,1.8,2,2.4,3.2c0.7,1.4,1,3,1,4.6
	C22.7,17.9,18,22.7,12.1,22.7z"/>
<path style="fill:#FFFFFF;" d="M12.1,22.7C6.2,22.7,1.4,17.9,1.4,12C1.4,6.1,6.1,1.3,12,1.3c2.7,0,5.3,1,7.3,2.8
	c1,0.9,1.8,2,2.4,3.2c0.7,1.4,1,3,1,4.6C22.7,17.9,18,22.7,12.1,22.7z"/>
<path id="Path_358" style="fill:#5FB546;" d="M18.9,7.1c-0.3-0.3-0.9-0.3-1.2,0l-7.8,7.8l-3.4-3.4c-0.3-0.3-0.9-0.3-1.2,0
	c-0.3,0.3-0.3,0.9,0,1.2l4.6,4.7l9-9C19.2,8,19.2,7.4,18.9,7.1C18.9,7.1,18.9,7.1,18.9,7.1z"/>
</svg>
